

	import {Options, Vue, Prop} from "vue-property-decorator";

	@Options({emits: ["click"]})
	export default class MicroButton extends Vue
	{
		@Prop({type: String, default: "13px"}) buttonLRPadding: string;
	}
